import { apiClient } from "../../../api/client";
import * as ActionType from "./withdraw.type";
import { setToast } from "../../../util/toast";

// GET WITHDRAW
export const getWithdraw = () => async (dispatch) => {
  const res = await apiClient.get("withdraw/getWithdrawRequest");
  if (res.ok) {
    dispatch({ type: ActionType.GET_WITHDRAW, payload: res.data?.withdraws });
  } else {
    console.error(res.message);
  }
};

// CREATE WITHDRAW
export const createWithdraw = (data) => async (dispatch) => {
  const res = await apiClient.post("withdraw/createWithdrawRequest", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_WITHDRAW, payload: res.data?.withdraw });
    setToast("success", "Withdraw created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

// UPDATE WITHDRAW
export const updateWithdraw = (data) => async (dispatch) => {
  const res = await apiClient.patch("withdraw/updateWithdrawRequest", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_WITHDRAW, payload: res.data?.withdraw });
    setToast("success", "Withdraw updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const enabledDisabled = (withdraw, isEnabled) => async (dispatch) => {
  const res = await apiClient.patch(
    `withdraw/enableDisableWithdraw?withdrawId=${withdraw?._id}&isEnabled=${isEnabled}`
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_WITHDRAW,
      payload: { data: res.data?.withdraw, id: withdraw?._id },
    });
    setToast("success", "Withdraw updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
